<div class="radio-holder">
  <div class="label">{{label}}</div>
    <div class="custom-radio" *ngFor="let option of options" >
    <input type="radio" id="{{ option }}" name="options" [(ngModel)]="selectedOption" [value]="option" />
    <label for="{{ option }}"(click)="onSelect(option)">
      <p class="text">{{ option }}</p>
      <div class="radio"></div>
    </label>
    <div *ngIf="!option">{{option}}</div>
  </div>
  
</div>
